import { useMemo } from 'react'
import { Theme, THEME_I18N_KEYS, Language, LANGUAGE_I18N_KEYS } from '../../../../../constants/enums'
import { useLocalization } from '../../../../../i18n'
import { enumToLocalizedAutocompleteOptions } from '../../../../../utils/enumUtils'

export function useSubMenuOptions() {
  const { t } = useLocalization()

  const themeOptions = useMemo(
    () => enumToLocalizedAutocompleteOptions(Theme, THEME_I18N_KEYS, t, {
      includeValues: [Theme.LIGHT, Theme.DARK, Theme.UNSPECIFIED]
    }),
    [t]
  )

  const languageOptions = useMemo(
    () => enumToLocalizedAutocompleteOptions(Language, LANGUAGE_I18N_KEYS, t, {
      includeValues: [
        Language.UNSPECIFIED,
        Language.RU,
        Language.EN,
        // Language.ES,
        // Language.FR,
        // Language.DE,
        // Language.ZH,
        // Language.IN,
        // Language.PT,
      ]
    }),
    [t]
  )

  return { themeOptions, languageOptions }
}
